/**
 * Extract a displayable country string from various country data formats.
 * Accepts a string country code or an object with Code2/Code3/Name fields.
 */
export function getCountryDisplay(country: any): string {
  if (!country) return '';
  if (typeof country === 'string') {
    return country;
  }
  if (typeof country === 'object') {
    return country.Code2 || country.Name || country.Code3 || '';
  }
  return '';
}
